module.exports = __webpack_public_path__ + "static/roam-the-lineup-1e0715dc567aeb5943b1131f0ca60dcb.svg";